export enum ResponseType {
  combo_box = "combo_box",
  check_box = "check_box",
  custom_links = "custom_links",
}
